import squareImg1 from "./gangBuilderSquare.jpg";
import squareImg3 from "./helpSquare.jpg";
import defaultImg1 from "./linkImg1.png";
import defaultImg2 from "./linkImg2.png";
import defaultImg3 from "./linkImg3.png";
import squareImg2 from "./rulesSquare.jpg";

export type NavImageSrc = {
  square: string;
  default: string;
};

export type NavLink = {
  href: string;
  heading: string;
  description: string;
  disabled?: boolean;

  /**
   * Required in practice for any link whose usage includes DASHBOARD_CARDS.
   * Left optional for now because this section is about to be reworked.
   */
  imageSrc?: NavImageSrc;
  usage: NavLinkUsage;
};

export enum NavLinkUsage {
  NONE = 0,

  DASHBOARD_LIST = 1 << 0,
  DASHBOARD_CARDS = 1 << 1,
  SIDEBAR = 1 << 2,

  DASHBOARD = DASHBOARD_LIST | DASHBOARD_CARDS,
  ALL = DASHBOARD_LIST | DASHBOARD_CARDS | SIDEBAR,
}

export const navLinks: NavLink[] = [
  {
    href: "~/gangs",
    heading: "Gang Builder",
    description: `Get your gang ready for the streets of Gnork in literal seconds.`,
    imageSrc: { default: defaultImg1, square: squareImg1 },
    usage: NavLinkUsage.ALL,
  },
  {
    href: "~/rules",
    heading: "Core Rules",
    description: `Download or buy the latest version of Space Gits core rules!`,
    imageSrc: { default: defaultImg2, square: squareImg2 },
    usage: NavLinkUsage.ALL,
  },
  {
    href: "~/rules/quick-start",
    heading: "Quick Start Rules",
    description: `Learn everything you need to know to play your first few games.`,
    usage: NavLinkUsage.DASHBOARD_LIST | NavLinkUsage.SIDEBAR,
  },
  {
    href: "~/names",
    heading: "Name Generator",
    description: `Generate random git, gnawball, or gang name.`,
    usage: NavLinkUsage.SIDEBAR,
  },
  {
    href: "~/docs",
    heading: "Help & Changelog",
    description: "Get support and learn what's new in the app.",
    imageSrc: { default: defaultImg3, square: squareImg3 },
    usage: NavLinkUsage.ALL,
  },
];
